import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore, ProjectViewProject } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { IconSize } from '@freelancer/ui/icon';
import * as Rx from 'rxjs';

@Component({
  template: `
    <fl-list [bottomBorder]="true">
      <fl-list-item>
        <fl-bit class="OverlayControls">
          <fl-icon class = "Icon"
            [name]="'ui-close'"
            [label] = "'ui-close'"
            [size]="IconSize.MID"
            (click)="handleClose()"
          ></fl-icon>
        </fl-bit>
      </fl-list-item>
    </fl-list>
  `,
  styleUrls: ['./project-view-overlay-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectViewOverlayModalComponent implements OnInit {
  IconSize = IconSize;

  @Input() projectId: number;

  project$: Rx.Observable<ProjectViewProject>;

  constructor(
    private modalRef: ModalRef<ProjectViewOverlayModalComponent>,
    private datastore: Datastore,
    private auth: Auth,
  ) {}

  ngOnInit() {
    this.project$ = this.datastore.object(
      'projectViewProjects',
      this.auth.getUserId(),
      this.projectId,
    );
  }

  handleClose() {
    this.modalRef.close();
  }
}
